import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Language } from '../../../helpers/types';
import { LanguagesState } from './types';

export const initialState: LanguagesState = {
  items: [],
  loading: false,
};

export const languagesSlice = createSlice({
  name: 'languages',
  initialState,
  reducers: {
    fetchRequest(state) {
      state.loading = true;
    },
    fetchSuccess(state, action: PayloadAction<Language[]>) {
      state.loading = false;
      state.items = action.payload;
    },
    fetchFailure(state) {
      state.loading = false;
    },
  },
});

export const { actions: languagesActions } = languagesSlice;

export const useLanguagesSlice = () => ({ actions: languagesSlice.actions });
